import { EntityBank } from "../../entity/EntityBank";

export class DtoBanksPutRes extends EntityBank {}
